import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Image, Row, Col } from "react-bootstrap";
import logoImg from "../../assets/images/logo.png";
import fb from "./../../assets/icons/facebook.png";
import insta from "./../../assets/icons/instagram.png";
import twitter from "./../../assets/icons/twitter.png";
import linkdin from "./../../assets/icons/linkedin (1).png";

class Footer extends Component {

	render() {

		const pathname = this?.props?.history?.location?.pathname;

		return (
			<div>
				{
					pathname.indexOf("/tutor-dashboard/TutorSettingBioAndSub/") === -1 ? (
						<div>
							<div className="footer-top">
							<Row className="flex-center-center m-0">
								<Col lg={10} md={11} sm={12} xs={12}>
								<div className="row">
									<div className="col-lg-3 mb-4">
									<h3>Askademia</h3>
									<ul className="footer-links">
										<li>
										<a href="/about">About</a>
										</li>
										<li>
										<a href="/profile">Profile</a>
										</li>
										<li>
										<a href="/login">Login</a>
										</li>
										<li>
										<a href="#">News</a>
										</li>
										<li>
										<a href="#">Policies</a>
										</li>
										<li>
										<a href="#">Help</a>
										</li>
										<li>
										<a href="#">Careers</a>
										</li>
										<li>
										<a href="#">Volunteer</a>
										</li>
										<li>
										<a href="#">Diversity and belonging</a>
										</li>
									</ul>
									</div>
									<div className="col-lg-3 mb-4">
									<h3>Discover</h3>
									<ul className="footer-links">
										<li>
										<a href="#">Trust and safety</a>
										</li>
										<li>
										<a href="#">Enrichment</a>
										</li>
									</ul>
									</div>
									<div className="col-lg-3 mb-4">
									<h3>Tutoring</h3>
									<ul className="footer-links">
										<li>
										<a href="#">Why tutor</a>
										</li>
										<li>
										<a href="#">Responsible tutoring</a>
										</li>
										<li>
										<a href="#">Tution centres</a>
										</li>
									</ul>
									</div>
									<div className="col-lg-3 mb-4">
									<h3>Social</h3>
									<ul className="footer-links">
										<li>
										<a href="#">Terms</a>
										</li>
										<li>
										<a href="#">Privacy</a>
										</li>
										<li>
										<a href="#">Site Map</a>
										</li>
									</ul>
									<div style={{ marginTop: "20px" }}>
										<Image style={{ marginRight: "5px" }} src={fb} />
										<Image style={{ margin: "0px 5px" }} src={insta} />
										<Image style={{ margin: "0px 5px" }} src={twitter} />
										<Image style={{ margin: "0px 5px" }} src={linkdin} />
									</div>
									</div>
								</div>
								</Col>
							</Row>
							</div>
							<footer className="footer-bottom">
							<Row className="flex-center-center m-0">
								<Col lg={10} md={11} sm={12} xs={12}
								>
								<div className="d-flex align-items-center">
									<img src={logoImg} alt="" width="34px" height="34px" />
									<p>&copy; 2020 Askademia . All Rights reserved.</p>
								</div>
								</Col>
								</Row>
							</footer>
						</div>		
					) : ""
				}
			</div>
		);
	}
}

export default withRouter(Footer);
